import type { FC } from 'react';
import { useCallback, useState } from 'react';
import DeleteRounded from '@mui/icons-material/DeleteRounded';
import { Box, IconButton, OutlinedInput } from '@mui/material';

import { SEARCH_FORM_SETTINGS } from 'src/constants/settings';

import { styles } from './index.styles';

export const LIST_SEARCH_TEST_ID = 'list-search-test-id';

export interface ListSearchProps {
  handleSearch: (value: string, searchParameter?: string) => void;
  searchParameter?: string;
  searchInputPlaceholder: string;
}

const ListSearch: FC<ListSearchProps> = ({
  handleSearch,
  searchParameter,
  searchInputPlaceholder,
}) => {
  const [value, setValue] = useState('');
  const handleInputChange = useCallback(
    (newValue: string) => {
      if (
        newValue.length === 0 ||
        newValue.length >= SEARCH_FORM_SETTINGS.MINIMUM_CHARACTERS
      ) {
        handleSearch(newValue, searchParameter);
      }
      setValue(newValue);
    },
    [setValue, handleSearch, searchParameter],
  );

  return (
    <Box data-test-id={LIST_SEARCH_TEST_ID} sx={{ position: 'relative' }}>
      <OutlinedInput
        size="small"
        fullWidth
        placeholder={searchInputPlaceholder}
        type="text"
        name="searchTerm"
        onChange={({ target }) => handleInputChange(target.value)}
        value={value}
        sx={styles.inputField}
      />
      <IconButton
        sx={styles.resetInputButton(!value)}
        disableRipple
        size="small"
        onClick={() => handleInputChange('')}
      >
        <DeleteRounded fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default ListSearch;
